import React from "react";
import { Card, Button } from "antd";
import styles from "./styles";
import "./productcard.css";

import {
  HeartOutlined,
  StarFilled,
  ShoppingCartOutlined,
} from "@ant-design/icons";

import img from "../../assets/Images/Goldin trout.png";

const ProductCard = (props) => {
  return (
    <>
      <Card bordered className="product-card">
        <div style={{ padding: "20px" }} id="product-card">
          <div style={styles.dFlex}>
            {props.new ? (
              <span style={styles.cardSpan}>{props.new}</span>
            ) : null}
            {props.sale ? (
              <span style={styles.cardSpan2}><del>{props.sale}</del></span>
            ) : null}
            {/* {props.heart ? (
              <span style={styles.heartIcon}>{props.heart}</span>
            ) : null} */}
          </div>
          <div style={styles.cardImage}>
            <img src={props.image} width="100%" alt="" />
          </div>
          <hr style={styles.separator} />
          <h2 style={styles.cardHeading}>{props.cardHeading}</h2>
          <div>
            <p style={{fontSize: '13px', color: 'gray'}}>
              {props.cardPara}
            </p>
            <span>
              <StarFilled style={styles.star} />
            </span>
            <span>
              <StarFilled style={styles.star} />
            </span>
            <span>
              <StarFilled style={styles.star} />
            </span>
            <span>
              <StarFilled style={styles.star} />
            </span>
            <span>
              <StarFilled style={styles.star} />
            </span>
          </div>
          <p style={styles.price}>{props.price}</p>
        </div>
        <div id="productCardBody">
          <div className="cardHoverDetails">
            <p style={styles.price2}>{props.price}</p>
            <Button
              type="primary"
              shape="round"
              icon={<ShoppingCartOutlined style={{ fontSize: "18px" }} />}
              size={"large"}
              style={styles.cardBtn}
              className="addToCartBtn"
              onClick={props.OnClick}
            >
              {props.cardBtn}
            </Button>
            <div style={{ marginTop: "20px" }} className="wishList">
              <span style={styles.wishList}>
                <HeartOutlined />
              </span>
              <span>Add To WishList</span>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
export default ProductCard;
